import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const types = {
  SET_WEBCONFIG: 'SET_WEBCONFIG',
  SET_PLATES: 'SET_PLATES',
  SET_IS_AUTNENTIATED: 'SET_IS_AUTNENTIATED', // 是否认证通过
  SET_USER: 'SET_USER' // 用户信息
}

const state = { // 需要维护的状态
  webConfigs: null,
  plates: [],
  isAutnenticated: false,  // 是否认证
  user: {}   // 存储用户信息
}
const getters = {
  isShow: state => {
    return state.plates.length && state.webConfigs
  },
  logopic: state => state.webConfigs.logopic,
  copyright: state => state.webConfigs.copyright,//网站版权信息
  recodenum: state => state.webConfigs.recodenum,//ICP备案号
  address: state => state.webConfigs.address,//公司地址
  email: state => state.webConfigs.email,//email
  name: state => state.webConfigs.name,//公司名称
  phone: state => state.webConfigs.phone,//手机号
  mobile: state => state.webConfigs.mobile,//电话
  shortname: state => state.webConfigs.shortname,//公司名称
  isAutnenticated: state => state.isAutnenticated,
  user: state => state.user
}
const mutations = {
  [types.SET_WEBCONFIG](state, data) {
    console.log("SET_WEBCONFIG", data);
    state.webConfigs = data;
  },
  [types.SET_PLATES](state, data) {
    console.log("SET_PLATES", data);
    state.plates = data;
  },
  [types.SET_IS_AUTNENTIATED](state, isAutnenticated) {
    if (isAutnenticated)
      state.isAutnenticated = isAutnenticated
    else
      state.isAutnenticated = false
  },
  [types.SET_USER](state, user) {
    if (user)
      state.user = user
    else
      state.user = {}
  }
}

const actions = {
  [types.SET_WEBCONFIG]({ commit }, data) {
    localStorage.setItem('sealpicsrc', data.sealpicsrc);
    commit(types.SET_WEBCONFIG, data)
  },
  [types.SET_PLATES]({ commit }, data) {
    commit(types.SET_PLATES, data)
  },
  setIsAutnenticated: ({ commit }, isAutnenticated) => {
    commit(types.SET_IS_AUTNENTIATED, isAutnenticated)
  },
  setUser: ({ commit }, user) => {
    commit(types.SET_USER, user)
  },
  clearCurrentState: ({ commit }) => {
    commit(types.SET_IS_AUTNENTIATED, false)
    commit(types.SET_USER, null)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
